import { gql } from "@apollo/client";

const VERIFY_PROMO_CODE = gql`
query verifyPromoCode($verifyPromoInput: VerifyPromoInput!) {
    verifyPromoCode(verifyPromoInput: $verifyPromoInput) {
        basePromoCode {
        _id
        promoCode
        validFrom
        validTo
        species
        hospital
        schemaName
        codeStatus
        discount
        message
        description
        }
        success
        messages
    }
}
`;

export default VERIFY_PROMO_CODE;

